import { pipe } from 'fp-ts/lib/function';
import { failure, parse, string, struct, success } from 'io-ts/Decoder';

import { CountryCode } from '../../../../country';

export const Request = struct({
	name: pipe(
		string,
		parse((s) => {
			const trimmed = s.trim();
			return trimmed.length > 0
				? success(trimmed)
				: failure(s, 'Organization name must not be empty');
		})
	),
	countryCode: CountryCode,
});
